import { render, staticRenderFns } from "./PermissionDeniedCard.vue?vue&type=template&id=4f98d065&scoped=true"
import script from "./PermissionDeniedCard.vue?vue&type=script&lang=js"
export * from "./PermissionDeniedCard.vue?vue&type=script&lang=js"
import style0 from "./PermissionDeniedCard.vue?vue&type=style&index=0&id=4f98d065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f98d065",
  null
  
)

export default component.exports